(function () {
  var form = document.getElementById('gko-rapport-form');
  if (!form) return;

  var endpoint = form.getAttribute('data-endpoint');
  var submitBtn = form.querySelector('[type="submit"]');
  var alertEl = form.querySelector('[data-form-alert]');
  var successEl = document.querySelector('[data-form-success]');
  var busyLabel = submitBtn ? submitBtn.getAttribute('data-busy') : '';

  function getToken() {
    var input = form.querySelector('[name="cf-turnstile-response"]');
    if (input && input.value) return input.value;
    if (window.turnstile && typeof window.turnstile.getResponse === 'function') {
      try {
        var response = window.turnstile.getResponse();
        if (response) return response;
      } catch (err) {
        /* widget not ready */
      }
    }
    return '';
  }

  function resetTurnstile() {
    if (window.turnstile && typeof window.turnstile.reset === 'function') {
      window.turnstile.reset();
    }
  }

  function clearErrors() {
    if (alertEl) {
      alertEl.hidden = true;
      alertEl.textContent = '';
    }
    form.querySelectorAll('[data-error-for]').forEach(function (el) {
      el.hidden = true;
      el.textContent = '';
    });
    form.querySelectorAll('[aria-invalid="true"]').forEach(function (el) {
      el.removeAttribute('aria-invalid');
    });
  }

  function showAlert(message) {
    if (!alertEl) return;
    alertEl.hidden = !message;
    alertEl.textContent = message || '';
  }

  function showFieldErrors(fieldErrors) {
    if (!fieldErrors) return;
    Object.keys(fieldErrors).forEach(function (key) {
      var msg = fieldErrors[key];
      if (!msg) return;
      var errorEl = form.querySelector('[data-error-for="' + key + '"]');
      if (errorEl) {
        errorEl.hidden = false;
        errorEl.textContent = msg;
      }
      var field = form.querySelector('[name="' + key + '"]');
      if (field) field.setAttribute('aria-invalid', 'true');
    });
  }

  function setBusy(isBusy) {
    if (!submitBtn) return;
    var label = submitBtn.querySelector('span') || submitBtn;
    if (!submitBtn.dataset.label) submitBtn.dataset.label = label.textContent;
    submitBtn.disabled = isBusy;
    label.textContent = isBusy ? busyLabel || submitBtn.dataset.label : submitBtn.dataset.label;
  }

  function parseJson(res) {
    return res.text().then(function (text) {
      if (!text) return { status: res.status, data: null };
      try {
        return { status: res.status, data: JSON.parse(text) };
      } catch (err) {
        return { status: res.status, data: null };
      }
    });
  }

  form.addEventListener('submit', function (event) {
    event.preventDefault();
    clearErrors();

    var token = getToken();
    if (!token) {
      showAlert('Bevestig dat u geen robot bent, of probeer het opnieuw.');
      resetTurnstile();
      return;
    }

    var nameField = form.querySelector('[name="name"]');
    var emailField = form.querySelector('[name="email"]');
    var organisationField = form.querySelector('[name="organisation"]');
    var sectorField = form.querySelector('[name="sector"]');
    var typeField = form.querySelector('[name="subscriberType"]:checked');
    var newsletterField = form.querySelector('[name="newsletter"]');
    var honeypotField = form.querySelector('[name="company_website"]');

    var body = {
      name: nameField ? nameField.value.trim() : '',
      email: emailField ? emailField.value.trim() : '',
      organisation: organisationField ? organisationField.value.trim() : '',
      sector: sectorField ? sectorField.value : '',
      subscriberType: typeField ? typeField.value : '',
      company_website: honeypotField ? honeypotField.value : '',
      'cf-turnstile-response': token
    };

    if (newsletterField && newsletterField.checked) {
      body.newsletter = true;
    }

    setBusy(true);

    fetch(endpoint, {
      method: 'POST',
      headers: {
        'content-type': 'application/json',
        accept: 'application/json'
      },
      body: JSON.stringify(body)
    })
      .then(parseJson)
      .then(function (result) {
        var data = result.data || {};
        if (result.status === 200 && data.ok === true) {
          form.classList.add('is-sent');
          if (successEl) {
            successEl.hidden = false;
            if (typeof successEl.focus === 'function') successEl.focus();
            successEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
          return;
        }
        showAlert(data.message || 'Er ging iets mis. Probeer het opnieuw.');
        showFieldErrors(data.fieldErrors);
        resetTurnstile();
      })
      .catch(function () {
        showAlert('Er ging iets mis. Probeer het opnieuw.');
        resetTurnstile();
      })
      .finally(function () {
        setBusy(false);
      });
  });
})();
